import React, { useEffect, useState } from "react";
import { SelectFilter } from "@design-system";
import { useFilteredClientSelectOptions } from "./use-filtered-client-select-options";
import { useLazyQuery } from "@apollo/client";
import { FIND_CLIENTS_BY_IDS } from "../../graphql/query";

export const ClientSelectContainer = ({
  onApplyFilter,
  onClearFilter,
  preselectedClientIds = [],
  selectedFilterValues = [],
}: {
  onApplyFilter: (values: number[]) => void;
  onClearFilter: () => void;
  preselectedClientIds?: number[];
  selectedFilterValues?: number[];
}) => {
  const [search, setSearch] = useState("");
  const [preselectedOptions, setPreselectedOptions] = useState<any[]>([]);

  const limit = 10;

  const { loading, options, fetchMore, getClients } = useFilteredClientSelectOptions(search, {
    limit,
    offset: 0,
  });

  const [getPreselectedClients] = useLazyQuery(FIND_CLIENTS_BY_IDS);

  const doOnLoadMore = fetchMore
    ? () => {
        fetchMore({
          variables: { limit, offset: options.length },
        });
      }
    : undefined;

  useEffect(() => {
    search && getClients();
  }, [search]);

  useEffect(() => {
    if (preselectedClientIds.length > 0) {
      getPreselectedClients({
        variables: {
          ids: preselectedClientIds,
        },
      }).then(({ data }) => {
        if (data?.getClientsByIds) {
          const clientOptions = data.getClientsByIds.map((client: any) => ({
            value: client.id,
            label: client.name,
          }));
          setPreselectedOptions(clientOptions);
        }
      });
    }
  }, [preselectedClientIds]);

  const allOptions = [...preselectedOptions, ...(options || [])].filter(
    (option, index, self) => index === self.findIndex((o) => o.value === option.value)
  );

  const defaultValues =
    selectedFilterValues.length > 0 ? selectedFilterValues : preselectedClientIds;

  return (
    <SelectFilter
      loading={loading}
      optionsLabel="clients"
      options={allOptions}
      defaultValue={defaultValues}
      onSearch={setSearch}
      onApplyFilter={onApplyFilter}
      onClearFilter={() => {
        setSearch("");
        onClearFilter();
      }}
      onLoadMore={doOnLoadMore}
    />
  );
};
